var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',{attrs:{"data":_vm.data,"highlight-current":true,"props":_vm.treeProps,"node-key":"SerialCodeId"},scopedSlots:_vm._u([{key:"default",fn:function({data}){return _c('span',{staticClass:"custom-tree-node",on:{"click":function($event){return _vm.onSelect(data)}}},[_c('span',[_vm._v(_vm._s(data.SerialType)+"编码")])])}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }